import { useNonF2fMedicalCategories } from '@/entities/medical-category';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { NonF2fMedicalCategory } from '@/types/bff/gql-schema';
import { ROUTES } from '@/types/common';
import { MEDICAL_CATEGORY_CONFIG } from '../lib/constants';

const MORE_CATEGORY_URL = 'https://d2m9duoqjhyhsq.cloudfront.net/diagnoses/etc/more_category.png';
const SPECIAL_TREATMENT_ID = '12';
const MEDICINE_UNIT_ID = 185;
const DEFAULT_REGION_CODE = 11;

const mapMedicalCategoryToRouteType = (category: string): ECategoryType => {
  if (category.toLowerCase() === 'treatment') {
    return ECategoryType.Treatment;
  }

  if (category.toLowerCase() === 'department') {
    return ECategoryType.Department;
  }

  if (category.toLowerCase() === 'vaccination') {
    return ECategoryType.Vaccination;
  }

  return ECategoryType.Treatment;
};

const useMedicalCategoryDisplayViewModel = (size = MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE - 1) => {
  const { medicalCategories, isLoading, error } = useNonF2fMedicalCategories(size);

  const getCategoryPath = (category: NonF2fMedicalCategory) => {
    if (category.id === 'more') {
      return `${ROUTES.TELEMEDICINE.CATEGORIES.path}`;
    }

    if ('category' in category && category.category === 'TREATMENT' && category.id === SPECIAL_TREATMENT_ID) {
      return `${ROUTES.NON_BENEFIT.HOME.path}?treatmentId=${category.id}&treatmentMedicineUnitId=${MEDICINE_UNIT_ID}&regionCode=${DEFAULT_REGION_CODE}`;
    }
    return ROUTES.TELEMEDICINE.DOCTORS.buildPath(mapMedicalCategoryToRouteType(category.category), category.id);
  };

  return {
    medicalCategories: [...medicalCategories, { id: 'more', name: '전체 보기', iconUrl: MORE_CATEGORY_URL }],
    isLoading,
    error,
    getCategoryPath,
  };
};

export default useMedicalCategoryDisplayViewModel;
